<template>
  <v-text-field v-model="value" dense clearable :clear-icon="closeIcon" :prepend-icon="filterIcon" @input="submit"
                :placeholder="$vuetify.lang.t(header)" class="input-width"></v-text-field>
</template>

<script>
import { mdiClose, mdiFilter } from '@mdi/js'
import debounce from 'lodash.debounce'

export default {
  name: 'textFilter',
  props: {
    column: String,
    header: String
  },
  data: () => ({
    value: '',

    filterIcon: mdiFilter,
    closeIcon: mdiClose
  }),
  methods: {
    submit:
      debounce(function () {
        this.$emit('value-changed', { column: this.column, value: this.value })
      }, 300)
  }
}
</script>

<style scoped>
  .input-width {
    width: 60%;
  }
</style>
